"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import Button from "@/components/ui/Button";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex items-center pt-20 min-h-[720px] lg:h-[720px]"
      style={{
        backgroundImage:
          "url('/images/Bloom-Wise_banner_background_desktop_design_1.webp'), linear-gradient(0deg, rgba(128, 128, 128, 0.2) 0%, rgba(128, 128, 128, 0.2) 100%), linear-gradient(0deg, rgba(52, 78, 65, 0.85) 0%, rgba(52, 78, 65, 0.85) 100%), url('/images/Bloom-Wise_footer_background_color_2.webp')",
        backgroundPosition: "0 76.853px, center, center, 50%",
        backgroundSize: "100% 89.905%, cover, cover, cover",
        backgroundRepeat: "no-repeat, no-repeat, no-repeat, no-repeat",
      }}
    >
      <div className="px-10 md:px-16 lg:px-[150px] w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-8 md:gap-10 lg:gap-[50px] py-16 md:py-16 lg:py-[100px]">
          {/* Text Content - centered on mobile/tablet, left on desktop */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-white space-y-6 text-center lg:text-left"
          >
            <h1
              className="text-white text-4xl md:text-[42px] lg:text-[50px]"
              style={{
                alignSelf: "stretch",
                fontWeight: 400,
                lineHeight: "1.2",
              }}
            >
              Una aplicación diseñada específicamente para optimizar el proceso
              de muestreo
            </h1>

            {/* App Store Badges - centered on mobile/tablet, left on desktop */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start pt-4 md:pt-4 lg:pt-6 gap-4 md:gap-6 lg:gap-10">
              <a
                href="https://drive.google.com/file/d/1dB5qjf2GuiIFtHiQvvJj6j2dLpMt3TV8/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity w-full max-w-[180px] md:max-w-[200px] lg:max-w-[250px]"
              >
                <Image
                  src="/images/google_play_button.svg"
                  alt="Disponible en Google Play"
                  width={250}
                  height={69}
                  className="w-full h-auto"
                />
              </a>
              {/* <a
                href="#"
                className="hover:opacity-80 transition-opacity w-full max-w-[180px] md:max-w-[200px] lg:max-w-[250px]"
              >
                <Image
                  src="/images/apple_store_button.svg"
                  alt="Disponible en App Store"
                  width={250}
                  height={69}
                  className="w-full h-auto"
                />
              </a> */}
            </div>
          </motion.div>

          {/* Hero Image/Mockup - responsive sizing and positioning */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative z-10 mx-auto lg:mx-0 -mb-[200px] md:-mb-[240px] lg:-mb-[300px] mt-15"
          >
            <div
              className="relative w-[90vw] max-w-[400px] md:max-w-[480px] lg:max-w-[620px] mx-auto lg:mx-0"
              style={{ aspectRatio: "714 / 524.15" }}
            >
              <Image
                src="/images/Bloom-Wise_banner_mockup.webp"
                alt="BloomWise App Mockup"
                fill
                className="object-contain"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
